export class DateUtils {

    public static getCurrentYear(): string {
        return new Date().getFullYear().toString();
    }

    public static getCurrentDate(): Date {
        return new Date();
    }

    public static addDays(date: Date, numberOfDays: number): Date {
        const newDate = new Date(date.getTime());
        newDate.setDate(date.getDate() + numberOfDays);
        return newDate;
    }

    public static reduceDays(date: Date, numberOfDays: number): Date {
        const newDate = new Date(date.getTime());
        newDate.setDate(date.getDate() - numberOfDays);
        return newDate;
    }

    public static resetTime(date: Date): Date {
        const newDate = new Date(date.getTime());
        newDate.setHours(0);
        newDate.setMinutes(0);
        newDate.setSeconds(0);
        return newDate;
    }

    public static calculateDifferenceDays(date01: Date, date02: Date): number {
        const timeDiff = Math.abs(date02.getTime() - date01.getTime());
        const diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));
        return diffDays;
    }

    public static calculateDifferenceMinutes(date01: Date, date02: Date): number {
        const timeDiff = Math.abs(date02.getTime() - date01.getTime());
        const diffDays = Math.round((timeDiff / 1000) / 60);
        return diffDays;
    }

    public static hasTime(date: Date): boolean {
        if (date.getHours() === 0 && date.getMinutes() === 0 && date.getSeconds() === 0) {
            return false
        }
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/_utils/services/dateUtils.ts